import { Table } from "react-bootstrap";

function FornosTable({ fornoObj }) {
    if (!fornoObj) {
        return <p className="text-center text-gray-600 mt-4">Carregando dados...</p>;
    }

    console.log(fornoObj)


    

    // Lista de informações a serem exibidas
    const dados = [
        { label: "Vagão Serial", value: fornoObj.vagao_Serial },
        { label: "Status Vagão", value: fornoObj.status_Vagao },
        { label: "Ordem Serial", value: fornoObj.ordem_Serial },
        { label: "Criação", value: ` ${fornoObj.usuario_Criacao ? fornoObj.usuario_Criacao : "" } / ${fornoObj.data_Criacao ? new Date(fornoObj.data_Criacao).toLocaleString() : ""} ` },
        { label: "Liberação", value: `${fornoObj.usuario_Liberacao ? fornoObj.usuario_Liberacao : ""} / ${fornoObj.data_Liberacao ? new Date(fornoObj.data_Liberacao).toLocaleString() : ""} ` },
        { label: "Criação", value: ` ${fornoObj.usuario_Entrada ? fornoObj.usuario_Entrada : ""} / ${fornoObj.data_Entrada ? new Date(fornoObj.data_Entrada).toLocaleString() : ""} ` },
        // Só o Forno S informa temperatura no apontamento de entrada.
        ...(fornoObj.temperatura_Entrada != null
            ? [{ label: "Temperatura Entrada", value: `${String(fornoObj.temperatura_Entrada).replace(".", ",")} °C` }]
            : []),
        { label: "Saida", value: ` ${fornoObj.usuario_Saida ? fornoObj.usuario_Saida : "" } / ${fornoObj.data_Saida ? new Date(fornoObj.data_Saida).toLocaleString() : ""} ` },
        { label: "Posição Lista", value: fornoObj.posicao_Lista },
        { label: "Status Peça", value: fornoObj.status_Peca },
        { label: "Lote / Codigo", value: `${fornoObj.molde_Lote} / ${fornoObj.molde_Codigo}` },
    ];

    return (
        <div className="bg-gray-100">
            <div className="max-w-md">
                <Table responsive className="table-column rounded-md bg-white">
                    <tbody >
                        {dados.map((item, index) => (
                            <tr key={index}>
                                <td className="text-start p-4 hover:bg-gray-50 flex items-center gap-2">
                                    <b><span  className="text-black font-bold text-2xl">{item.label}</span>: </b>
                                    <span className="text-gray-950 font-medium text-md">{item.value || ""}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>

    );
}

export default FornosTable;
